import axios from "axios";

const loadingStart = () => window.dispatchEvent(new Event("harwin:http:start"));
const loadingEnd = () => window.dispatchEvent(new Event("harwin:http:end"));

// ✅ REQUEST INTERCEPTOR - Adds token to every request
axios.interceptors.request.use(
  (config) => {
    if (!config.skipGlobalLoading) {
      config.__harwinGlobalLoading = true;
      loadingStart();
    }
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    loadingEnd();
    return Promise.reject(error);
  },
);

// ✅ RESPONSE INTERCEPTOR - Handles auth errors
axios.interceptors.response.use(
  (response) => {
    if (response.config?.__harwinGlobalLoading) loadingEnd();
    return response;
  },
  (error) => {
    if (error.config?.__harwinGlobalLoading) loadingEnd();
    const status = error.response?.status;
    const requestUrl = error.config?.url || "";

    // ✅ FIX: Skip interceptor logic for login/reset endpoints
    // A 401 on /login means wrong password — NOT an expired token
    const isAuthEndpoint =
      requestUrl.includes("/login") ||
      requestUrl.includes("/reset-password") ||
      requestUrl.includes("/debug-user");

    if (status === 403) {
      const message = "You do not have permission to work on this. If you need access, contact your higher authority or HR.";
      window.dispatchEvent(new CustomEvent("harwin:access-denied", { detail: { message } }));
      let el = document.getElementById("harwin-access-toast");
      if (!el) { el = document.createElement("div"); el.id="harwin-access-toast"; Object.assign(el.style,{position:"fixed",right:"24px",top:"84px",zIndex:"99999",maxWidth:"420px",background:"#fff7ed",color:"#9a3412",border:"1px solid #fdba74",borderRadius:"10px",padding:"14px 18px",boxShadow:"0 10px 30px rgba(0,0,0,.15)",fontWeight:"600"}); document.body.appendChild(el); }
      el.textContent = message; el.style.display="block"; clearTimeout(window.__harwinAccessToastTimer); window.__harwinAccessToastTimer=setTimeout(()=>{el.style.display="none"},5000);
    }

    if (status === 401 && !isAuthEndpoint) {
      console.error("❌ 401 Unauthorized - Token invalid/expired");

      const currentPath = window.location.pathname;

      if (!currentPath.includes("/login")) {
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default axios;
